import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../application/security/authentication.service';
import {HomeComponent} from '../home/home.component';
import {LogoutComponent} from '../logout/logout.component';

@Component({
             selector: 'app-login',
             template: ''
           })
export class LoginComponent implements OnInit {

  static readonly LOGIN_URL = 'login';

  constructor(private authenticationService: AuthenticationService,
              private router: Router) {
  }

  public ngOnInit(): void {
    this.navigateToCorrectPath();
  }

  private navigateToCorrectPath(): void {
    this.authenticationService.verifyAuthenticatedDashboardAccess()
        .subscribe(() => {
            this.navigateToHome();
        }, (error) => {
          console.error(error);
          this.navigateToLogout();
        });
  }

  private navigateToLogout(): void {
    this.router.navigateByUrl(LogoutComponent.LOGOUT_URL);
  }

  private navigateToHome(): void {
    this.router.navigateByUrl(HomeComponent.HOME_URL);
  }
}
